import React, { useContext, Fragment, useEffect } from "react";
import { OrigemLeadContext } from "../OrigemLeadContext";
import Pesquisar from "../../../../../Components/Cadastro/Pesquisar/Pesquisar";
import TabelaResultados from "../../../../../Components/Cadastro/TabelaResultados/TabelaResultados";

const PesquisarOrigemLead = () => {
  const { values, setValues, resetScreen } = useContext(OrigemLeadContext);

  useEffect(() => {
    resetScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        [name]: value,
      },
    });
  }

  return (
    <Fragment>
      <Pesquisar context={OrigemLeadContext}>
        <div className="col-12 col-md-2">
          <label>Código</label>
          <input
            className="form-control"
            type="text"
            name="origemLeadCod"
            value={values.searchData.origemLeadCod}
            onChange={onChangeInput}
          />
        </div>

        <div className="col-12 col-md-4">
          <label>Origem dos Leads</label>
          <input
            className="form-control"
            type="text"
            name="origemLeadNome"
            value={values.searchData.origemLeadNome}
            onChange={onChangeInput}
          />
        </div>
      </Pesquisar>
      <TabelaResultados context={OrigemLeadContext} />
    </Fragment>
  );
};

export default PesquisarOrigemLead;
